import { render, staticRenderFns } from "./PremiumGateWorkflows.vue?vue&type=template&id=1cb73ba0&scoped=true&"
import script from "./PremiumGateWorkflows.vue?vue&type=script&lang=js&"
export * from "./PremiumGateWorkflows.vue?vue&type=script&lang=js&"
import style0 from "./PremiumGateWorkflows.vue?vue&type=style&index=0&id=1cb73ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb73ba0",
  null
  
)

export default component.exports